import {Event, EventType} from "../../../services/events.service";

export class CalendarEvent {

  constructor(public originalEvent: Event) {
  }

  public get title() {
    if (this.originalEvent.type == EventType.DISPOSAL_AVAILABLE) {
      return 'Dostępny';
    } else if (this.originalEvent.type == EventType.DISPOSAL_NOT_AVAILABLE) {
      return 'Niedostępny';
    } else if (this.originalEvent.type == EventType.RESERVATION_WAITING || this.originalEvent.type == EventType.RESERVATION_CONFIRMED) {
      return this.originalEvent.title;
    }
  }

  public get start() {
    return this.originalEvent.start;
  }

  public get end() {
    return this.originalEvent.end;
  }

  public get displayEnd() {
    if (this.allDay) {
      const date = new Date(this.end);
      const previousDayDate = new Date(date.getTime() - 1);
      return previousDayDate.toJSON();
    } else {
      return this.end;
    }
  }

  public get allDay() {
    return this.originalEvent.type == EventType.DISPOSAL_AVAILABLE || this.originalEvent.type == EventType.DISPOSAL_NOT_AVAILABLE;
  }

  public get color() {
    if (this.originalEvent.type == EventType.DISPOSAL_AVAILABLE) {
      return '#15c377';
    } else if (this.originalEvent.type == EventType.DISPOSAL_NOT_AVAILABLE) {
      return '#f96868';
    } else if (this.originalEvent.type == EventType.RESERVATION_CONFIRMED) {
      return '#48b0f7';
    } else if (this.originalEvent.type == EventType.RESERVATION_WAITING) {
      return '#faa64b';
    }
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/calendar/calendar-event.ts